import(/* webpackMode: "eager" */ "/vercel/path0/images/header_page.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
